import {humanEnumeration} from '../utils';
import {ClassChooseItem} from './class-choose-item';
import {formatClassChooseOption} from './format-class-choose-option';

export const formatClassChoose = (chooseItem: ClassChooseItem) => {
	let list = null;
	const options = chooseItem.options;
	if (options) {
		list = humanEnumeration(options.map((option) => formatClassChooseOption(option, chooseItem.key)).sort(), 'или');
	}

	switch (chooseItem.key) {
		case 'skill':
			return list ? `_Выберите ${chooseItem.max}:_ ${list}` : `Выберите любые ${chooseItem.max} навыка `;
		case 'musicalInstrumentProficiency':
			return `Выберите ${chooseItem.max} Музыкальных инструмента`;
		case 'toolsProficiency':
		case 'armorProficiency':
		case 'weaponProficiency':
			return list;
	}
};
